import React from "react";

function Loader2({ height, width, margin, color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        margin: margin || ".2em 0",
        background: "none",
        display: "inline-block",
        shapeRendering: "auto",
      }}
      width={width || "60px"}
      height={height || "60px"}
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <circle
        cx="50"
        cy="50"
        fill="none"
        stroke={color || "#000000"}
        strokeWidth="10"
        r="35"
        strokeDasharray="164.93361431346415 56.97787143782138"
        transform="rotate(87.593 50 50)"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          repeatCount="indefinite"
          dur="1s"
          values="0 50 50;360 50 50"
          keyTimes="0;1"
        ></animateTransform>
      </circle>
    </svg>
  );
}

export default Loader2;
